import React, { useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import { useStudent } from '../../DataStore/StudentContext';
import ajaxStudent from '../../util/remote/ajaxStudent';

const AlertDeleteFile = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const { deleteFile, setDeleteFile, getStudentAttachments, studentId} = useStudent();


    const handleClose = () => setDeleteFile({ show: false, contact: null });


   if (!deleteFile.file) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxStudent.deleteStudentFile(deleteFile.file.id);
        setLoading(false);
        if(server_response.status === "OK"){
            getStudentAttachments(studentId); // Refresh contacts
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={deleteFile.show}
            onClose={handleClose}
            title="Delete File"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Delete
                    </button>
                    </>}
                </>
            }
        >


            {deleteFile.file && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Are you sure you want delete this student file <i>{deleteFile.file.file_name}</i> ?</h5>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDeleteFile;
